import React, { useState } from "react";

export default function UsageHistoryModal({
  isOpen,
  onClose,
  usageShistoryList = [],
  usageSMSHistoryList = [],
  selectedMonth = "",
}) {
  console.log("usageSMSHistoryList", usageSMSHistoryList);
  if (!isOpen) return null;
  const formatDuration = (duration) => {
    if (duration >= 60) {
      const minutes = Math.floor(duration / 60);
      const seconds = (duration % 60).toFixed(2);
      return `${minutes}m ${seconds}s`;
    }
    return `${duration.toFixed(2)}s`;
  };

  const [year, month] = selectedMonth.split("_");
  const monthName = new Date(`${year}-${month}-01`).toLocaleString("default", {
    month: "long",
  });
  const currentMonthYear = `${monthName} ${year}`;
  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <h2 style={styles.header}>Usage History for {currentMonthYear}</h2>
        <div style={styles.tableContainer}>
          <table style={styles.table}>
            <thead style={styles.thead}>
              <tr>
                <th colSpan={5} style={styles.th_title}>
                  Call Logs
                </th>
              </tr>
              <tr>
                <th style={styles.th}>Id</th>
                <th style={styles.th}>Customer</th>

                <th style={styles.th}>Duration</th>
                <th style={styles.th}>Started At</th>
                <th style={styles.th}>Ended At</th>
              </tr>
            </thead>
            <tbody>
              {usageShistoryList.map((item, index) => (
                <tr key={index}>
                  <td style={styles.td}>{item.id}</td>
                  <td style={styles.td}>
                    {item.customer_name == "" ||
                    item.customer_name == undefined ||
                    item.customer_name == null ? (
                      item.customer_number
                    ) : (
                      <div>
                        <div>{item.customer_name}</div>
                        <div style={styles.subtitle}>
                          {item.customer_number}
                        </div>
                      </div>
                    )}
                  </td>

                  <td style={styles.td}>
                    {formatDuration(item.duration_seconds)}
                  </td>
                  <td style={styles.td}>
                    {new Date(item.started_at).toLocaleString("en-AU", {
                      timeZone: "Australia/Sydney",
                    })}
                  </td>
                  <td style={styles.td}>
                    {new Date(item.ended_at).toLocaleString("en-AU", {
                      timeZone: "Australia/Sydney",
                    })}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div
          style={{
            marginBottom: 42,
          }}
        ></div>
        <div style={styles.tableContainer}>
          <table style={styles.table}>
            <thead style={styles.thead}>
              <tr>
                <th colSpan={6} style={styles.th_title}>
                  SMS Logs
                </th>
              </tr>
              <tr>
                <th style={styles.th}>Id</th>

                <th style={styles.th}>Direction</th>

                <th style={styles.th}>From</th>
                <th style={styles.th}>To</th>
                <th style={styles.th}>Number of Segments</th>
                <th style={styles.th}>Date</th>
              </tr>
            </thead>
            <tbody>
              {usageSMSHistoryList.map((item, index) => (
                <tr key={index}>
                  <td style={styles.td}>{item.id}</td>

                  <td style={styles.td}>
                    {item.direction == "outbound-api" ? "Outbound" : "Inbound"}
                  </td>

                  <td style={styles.td}>{item.from}</td>
                  <td style={styles.td}>{item.to}</td>
                  <td style={styles.td}>{item.num_segments}</td>
                  <td style={styles.td}>
                    {new Date(item.date_created).toLocaleString("en-AU", {
                      timeZone: "Australia/Sydney",
                    })}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <button style={styles.closeButton} onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
}

const styles = {
  subtitle: {
    color: "#555",
    fontSize: "0.85em",
    marginTop: "2px",
  },
  thead: {
    position: "sticky",
    top: 0,
    background: "white",
    zIndex: 1,
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1050,
  },
  modal: {
    background: "white",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    minWidth: "300px",
    maxWidth: "90%",
    maxHeight: "90vh",
    overflowY: "auto",
  },
  header: {
    marginTop: 0,
  },
  tableContainer: {
    maxHeight: "500px",
    overflowY: "auto",
    marginBottom: "20px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: 0,
    borderTop: "1px solid #ccc",
  },
  th_title: {
    textAlign: "center",
    fontWeight: "bold",
    borderBottom: "2px solid #ddd",
  },
  th: {
    borderBottom: "2px solid #ddd",
    padding: "8px",
    textAlign: "left",
    transform: "translateY(-2px)",
  },
  td: {
    borderBottom: "1px solid #ddd",
    padding: "8px",
  },
  closeButton: {
    background: "red",
    color: "white",
    border: "none",
    padding: "10px 20px",
    borderRadius: "4px",
    cursor: "pointer",
  },
};
